var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactSurveyElement } from "./reactquestion_element";
import { SvgIcon } from "./components/svg-icon/svg-icon";
var SurveyQuestionTagboxItem = /** @class */ (function (_super) {
    __extends(SurveyQuestionTagboxItem, _super);
    function SurveyQuestionTagboxItem(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(SurveyQuestionTagboxItem.prototype, "question", {
        get: function () {
            return this.props.question;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionTagboxItem.prototype, "item", {
        get: function () {
            return this.props.item;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionTagboxItem.prototype.canRender = function () {
        return !!this.item && !!this.question;
    };
    SurveyQuestionTagboxItem.prototype.renderElement = function () {
        var _this = this;
        var text = this.renderLocString(this.item.locText);
        var removeItem = function (event) {
            _this.question.dropdownListModel.deselectItem(_this.item.value);
            event.stopPropagation();
        };
        return (React.createElement("div", { className: "sv-tagbox__item" },
            React.createElement("div", { className: "sv-tagbox__item-text" }, text),
            React.createElement("div", { className: this.question.cssClasses.cleanItemButton, onClick: removeItem },
                React.createElement(SvgIcon, { className: this.question.cssClasses.cleanItemButtonSvg, iconName: this.question.cssClasses.cleanItemButtonIconId, size: "auto" }))));
    };
    return SurveyQuestionTagboxItem;
}(ReactSurveyElement));
export { SurveyQuestionTagboxItem };
